import DetailsAction from "./details-action";
import Block from '../block'
import {
    aspectRatio,
    backgroundColour,
    backgroundPattern,
    frameType,
    objectFit,
    setTitleDecorationByClass,
    setTitleDecorationByElement,
    textAlignment
} from "../../utils/block-utils";
import classNames from "classnames";
import Action from "../../components/action";
import {Image} from "../../components/image";
import Video from "../../components/video";

const Container = (props) => {
    return (
        <div className={classNames(
            props.className,
            !props.values.options?.inset ? backgroundPattern(props) : null,
            (!props.values.options?.inset && !props.values.alternateBackgroundColours) ? backgroundColour(props.values.options?.backgroundColour) : null)
        }>
            <div className={classNames(
                "mx-auto max-w-7xl section flex flex-col items-center",
                textAlignment(props),
                !props.values.alternateBackgroundColours ? backgroundColour(props.values.options?.backgroundColour) : null,
                backgroundPattern(props),
                props.values.options?.inset ? 'rounded-theme' : null,
                props.values.options?.inset ? backgroundPattern(props) : null,
                (props.values.options?.inset && !props.values.alternateBackgroundColours) ? backgroundColour(props.values.options?.backgroundColour) : null,
                props.sectionClassName,
            )}>
                {props.children}
            </div>
        </div>
    )
}

export default function Design5(props) {
    return (
        <Block {...props} className={props.className}>
            {props.values?.title || props.values.text ?
                <Container {...props} sectionClassName={props.values.items?.length > 0 ? '!pb-0' : null}>
                    <div className={"w-full"}>
                        {props.values?.title ? (
                            <>
                                <h3
                                    data-title=""
                                    className={classNames("relative rich-text", setTitleDecorationByClass(props.values?.options?.titleDecoration))}
                                    dangerouslySetInnerHTML={{__html: props.values.title}}/>
                                {props.values?.options?.titleDecoration &&
                                    setTitleDecorationByElement(props.values?.options?.titleDecoration)
                                }
                            </>
                        ) : null}
                        <div
                            data-body=""
                            dangerouslySetInnerHTML={{__html: props.values.text}}
                            className={"rich-text"}
                        />
                    </div>
                </Container>
                : null}
            <div className={classNames("relative w-full overflow-x-auto")}>
                {props?.state === 'placeholder' ?
                    <Container {...props}>
                        <div dangerouslySetInnerHTML={{__html: props.values.placeholderText}} className={"rich-text "}/>
                    </Container> :
                    <ul
                        data-list=""
                        className={classNames(
                            "sm:space-x-4 mb-3 lg:space-x-0 lg:grid lg:gap-x-4")}>
                        {props.values.items?.map((item, i) => {
                            const mediaType = item.mediaType || 'image';
                            const showImage = mediaType === 'image' && item.image;
                            const showVideo = mediaType === 'video';

                            return (
                                <li key={i} data-list-item="" className={classNames(
                                    (props.values.alternateBackgroundColours && i % 2 === 0) ? backgroundColour(props.values.options?.firstBackgroundColour) : backgroundColour(props.values.options?.secondBackgroundColour),
                                )}>
                                    <Container {...props}>
                                        <div
                                            className="group relative w-full space-y-4 sm:grid sm:grid-cols-2 sm:space-y-0 section !p-0">
                                            {(showImage || showVideo) && (
                                                <div className={classNames(
                                                    i % 2 === 0 ? null : 'order-1',
                                                    "overflow-hidden sm:row-span-2 relative rounded-theme",
                                                    aspectRatio(props),
                                                    frameType(props) === 'circle' ? 'clip-circle' : '',
                                                    frameType(props) === 'slant' ? 'clip-slant !rounded-none' : ''
                                                )}>
                                                    {showImage ? (
                                                        <Image
                                                            className={classNames(
                                                                " w-full h-full object-center",
                                                                objectFit(props.values.options?.imagePresentation),
                                                                item.action && item.action.type && !['button', 'buttonFull', 'link'].includes(props.values?.options?.actionStyle) ? 'group-hover:opacity-75' : '',
                                                                frameType(props) === 'slant' ? '!rounded-none' : ''
                                                            )}
                                                            width={props.imageWidth}
                                                            id={item.imageState?.__cx__?.id ? `image_${item.imageState?.__cx__?.id}` : null}
                                                            src={item.imageState?.__cx__?.key || item.image}
                                                            key={item.image + item.imageState + props.values?.options?.imagePresentation}
                                                            alt={item?.altText}
                                                        />
                                                    ) : null}
                                                    {showVideo ? (
                                                        <Video
                                                            {...item.video}
                                                            muted={item.video?.playing}
                                                            aspectRatio={aspectRatio(props)}
                                                            height={"100%"}
                                                            width={"100%"}
                                                            className={"absolute inset-0 w-full h-full"}
                                                        />
                                                    ) : null}
                                                </div>
                                            )}
                                            <div className="sm:col-span-1">
                                                <div className={classNames(textAlignment(props))}>
                                                    <h5>
                                                        {!(props.values?.options?.detailsAsPrimary && item?.detailsPopup?.label) && (!props.values?.options?.actionStyle || props.values?.options?.actionStyle === 'noStyle') &&
                                                            <Action {...item}
                                                                    action={{...item.action, label: undefined}}
                                                                    itemActionStyle={props.values?.options?.actionStyle}
                                                                    title={null}
                                                                    button={false}
                                                                    defaultHref={'#'}>
                                                                <span className="absolute inset-0"/>
                                                            </Action>
                                                        }
                                                        <span
                                                            data-title=""
                                                            className={"rich-text"}
                                                            dangerouslySetInnerHTML={{__html: item.title}}/>
                                                    </h5>
                                                    {item.text ? (
                                                        <div
                                                            data-body=""
                                                            dangerouslySetInnerHTML={{__html: item.text}}
                                                            className={"mt-1 rich-text"}
                                                        />
                                                    ) : null}
                                                    {!(props.values?.options?.detailsAsPrimary && item?.detailsPopup?.label) && props.values?.options?.actionStyle !== 'noStyle' && props.values?.options?.actionStyle &&
                                                        <div className={"mt-auto"}>
                                                            <Action className={"mt-3 mb-2"} {...item}
                                                                    itemActionStyle={props.values?.options?.actionStyle}
                                                                    title={null}/>
                                                        </div>
                                                    }
                                                    <DetailsAction detailsPopup={item?.detailsPopup} onOpenModal={props.handleOpenModal} primary={props.values?.options?.detailsAsPrimary}/>
                                                </div>
                                            </div>
                                        </div>
                                    </Container>
                                </li>
                            )
                        })}
                    </ul>
                }
            </div>

            {props.values.showingActionButton &&
                <Container {...props}>
                    <Action {...props.values} title={null}/>
                </Container>
            }
        </Block>
    )
}